import { render } from "./SamplingList.vue?vue&type=template&id=0c7c8741"
import script from "./SamplingList.vue?vue&type=script&lang=js"
export * from "./SamplingList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__